import React from 'react'
import discover from '../../../assets/images/discover-authentic-img.jpg'

export default function ThirdSection() {
  return (
    <section className="discover_authentic_sec section-equal-padding bg-white">
        <div className="container-fluid">
            <div className="row">
                <div className="col-md-6">
                    <div className="discover_authentic_img"
                        uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: false">
                        <img src={discover} alt="discover-authentic-img" loading='lazy'/>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="section-top-heading"
                        uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: false">
                        <h2 className="mb-3 text-black">Discover Authentic Atlanta Experiences</h2>
                        <p>Immerse yourself in the vibrant tapestry of Atlanta's culture, where every corner resonates
                            with history, music, and Southern charm. Savor the mouthwatering flavors of traditional
                            Southern cuisine, from savory fried chicken to delicious peach cobbler, and experience the
                            warm hospitality that defines Atlanta's spirit.</p>
                        <p>Wander through historic neighborhoods, explore iconic landmarks like the Martin Luther King
                            Jr. National Historic Site, and dive into the lively arts scene with soul-stirring live
                            performances. Whether you're indulging in a delicious meal at a renowned soul food
                            restaurant, enjoying a thrilling evening at a jazz club, or simply soaking up the vibrant
                            energy of a bustling street fair, Atlanta offers a rich tapestry of experiences that promise
                            to enchant and inspire.</p>
                        <p>With MySittiVacation, uncover the unique essence of Atlanta and create unforgettable memories
                            in a city that blends tradition with modernity. So pack your bags, embrace the Southern
                            hospitality, and let Atlanta captivate you like never before!</p>
                    </div>
                </div>
            </div>
        </div>
    </section>

  )
}
